import { Collapsible } from '../interfaces';

import { CompSearchJurisdiction } from './comp-search-jurisdiction';

export class PbaComparabilitySearch implements Collapsible {
  id: number;
  pbaId: number;
  name: string;
  watchedPli: number;
  description: string;
  status: string;
  isComplete: boolean;
  containerId: number;
  jurisdictions: CompSearchJurisdiction[];
  collapsed: boolean;
}
